<app-consultant [timeZoneClient]="timeZoneClient" servicetype="Audiotel" setfilter="true">

</app-consultant>
